import type { ProductIngredient } from "@workspace/product-catalog-types/types";
import { Badge } from "@workspace/ui/components/badge";
import { cn } from "@workspace/ui/lib/utils";

import type { SelectedOptionGroup } from "../../types";

interface OptionsSummaryProps {
	selectedOptions?: SelectedOptionGroup[];
	removedIngredients?: ProductIngredient[];
	className?: string;
}

/**
 * Displays selected options as a formatted summary badge
 * Examples: "+Cheese, No Onion", "Medium, Extra Hot"
 */
export function OptionsSummary({
	selectedOptions = [],
	removedIngredients = [],
	className,
}: OptionsSummaryProps) {
	const summary = [
		...selectedOptions.flatMap((x) => x.selectedItems.map((i) => i.name)),
		...removedIngredients.map((ing) => `No ${ing.stockItemName}`),
	].join(", ");

	return (
		<Badge variant="outline" className={cn("border-primary", className)}>
			{summary}
		</Badge>
	);
}
